"use client";

import React from "react";

//Type
import {
  CardCashierType,
  CardEmployeeProps,
  TableEmployeeProps,
} from "@/types";

//Style
import * as S from "./styles";

//Icons
import {
  BadgeDollarSign,
  BaggageClaim,
  BanknoteArrowDown,
  BanknoteArrowUp,
  CalendarDays,
  Coins,
  DollarSign,
  LogOut,
  Mail,
  Pencil,
  Percent,
  PhoneCall,
  Scissors,
  ShoppingCart,
  Star,
  Trash,
  User,
  Users,
} from "lucide-react";

//Images
import ImageUser from "@/assets/images/image-default.png";

//Components
import ButtonIcon from "../buttonIcon";
import Button from "../button";
import Start from "../start";
import { Swiper, SwiperSlide } from "swiper/react";
import AlertModal from "../alertModal";

import { formatCurrency } from "@/utils/formatCurrency";

const CardCashier: React.FC<CardCashierType> = ({
  className,
  data,
  handleUpdate,
  handleRemove,
  dict,
  handleCloseCashRegister,
  currency,
}) => {
  const [openAlertId, setOpenAlertId] = React.useState<number | null>(null);

  const handleConfirm = () => {
    if (openAlertId !== null) {
      handleCloseCashRegister(openAlertId);
      setOpenAlertId(null);
    }
  };

  const handleCancel = () => {
    setOpenAlertId(null);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          marginBottom: "10px",
        }}
      >
        {data.length > 0 ? (
          data.map((item, index: number) => (
            <div key={index} style={{ minWidth: "350px", flex: "1" }}>
              <S.CardService className={className}>
                <S.HeaderCard>
                  <S.FirstBox>
                    <S.BoxImage>
                      <S.BoxAlertProduct $isLowStock={!!item.closed_at}>
                        {item.closed_at
                          ? dict["Closed Cash Register"]
                          : dict["Open Cash Register"]}
                      </S.BoxAlertProduct>
                      <S.ImageEmployee src={ImageUser} />
                    </S.BoxImage>
                    <S.TitleCard>{item.name}</S.TitleCard>
                  </S.FirstBox>
                  {!item.closed_at && (
                    <S.ButtonCloseBox
                      icon={<BadgeDollarSign />}
                      text={dict["To Close"]}
                      variant="danger"
                      onClick={() => setOpenAlertId(Number(item.id))}
                    />
                  )}
                </S.HeaderCard>
                <S.BodyCard>
                  <S.ListItemEMployees>
                    <S.ItemEmployee>
                      <ShoppingCart />
                      {dict["Total Sales"]}:{" "}
                      {formatCurrency(Number(item.totalSales), currency)}
                    </S.ItemEmployee>
                    <S.ItemEmployee>
                      <Percent />
                      {dict.Fees}: {formatCurrency(Number(item.fees), currency)}
                    </S.ItemEmployee>
                    <S.ItemEmployee>
                      <BanknoteArrowUp />
                      {dict["Change Entry"]}:{" "}
                      {formatCurrency(Number(item.cashIn), currency)}
                    </S.ItemEmployee>
                    <S.ItemEmployee>
                      <BanknoteArrowDown />
                      {dict["Bleeding Output"]}:
                      {formatCurrency(Number(item.cashOut), currency)}
                    </S.ItemEmployee>
                    <S.ItemEmployee>
                      <Coins />
                      {dict["Cash Sales"]}:{" "}
                      {formatCurrency(Number(item.cashSales), currency)}
                    </S.ItemEmployee>
                    <S.ItemEmployee>
                      <DollarSign />
                      {dict["Balance"]}:{" "}
                      {formatCurrency(Number(item.cashBalance), currency)}
                    </S.ItemEmployee>
                  </S.ListItemEMployees>
                  {item.salesByPaymentMethod &&
                    item.salesByPaymentMethod.length > 0 && (
                      <S.PaymentMethodList>
                        <S.TitlePaymentMethod>
                          {dict["Sales by Payment Method"]}:
                        </S.TitlePaymentMethod>
                        {item.salesByPaymentMethod.map((method, i) => (
                          <S.PaymentMethodItem key={i}>
                            {method.payment_method?.name ?? dict["Unknown"]}:{" "}
                            {formatCurrency(Number(method.total), currency)}
                          </S.PaymentMethodItem>
                        ))}
                      </S.PaymentMethodList>
                    )}
                </S.BodyCard>
                <S.FooterCard>
                  {!item.closed_at && (
                    <>
                      <Button
                        text="Troco"
                        icon={<BadgeDollarSign />}
                        variant="success"
                        onClick={() => handleUpdate(Number(item.id))}
                      />
                      <Button
                        text="Sangria"
                        icon={<LogOut />}
                        variant="danger"
                        onClick={() => handleRemove(Number(item.id))}
                      />
                    </>
                  )}
                </S.FooterCard>
              </S.CardService>
              <AlertModal
                messageAlert={
                  dict["Do you really want to close the cash register?"]
                }
                open={openAlertId === Number(item.id)}
                onOpenChange={(isOpen) =>
                  isOpen
                    ? setOpenAlertId(Number(item.id))
                    : setOpenAlertId(null)
                }
                confirm={handleConfirm}
                cancel={handleCancel}
              />
            </div>
          ))
        ) : (
          <div>No cash registers available</div>
        )}
      </div>
    </>
  );
};

export default CardCashier;
